exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style_topbar__3O9OO {\n  background: #fff;\n  padding: 0 1.53rem;\n  min-height: 64px;\n  height: 64px;\n  border-bottom: 1px solid #e4e9f0;\n  color: #74708d;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center; }\n", ""]);

// Exports
exports.locals = {
	"topbar": "style_topbar__3O9OO"
};